export const COMPONENT_NAME = "currency-block";
